import { Action, ActionReducer, createReducer, on } from "@ngrx/store";
import {
  GetSkillsCheckResult,
  GetSkillsCheckResultByLearnerId,
  GetSkillsCheckResultError,
  GetSkillsCheckResultSuccess,
  IsSkillsCheckEnabled,
  IsSkillsCheckEnabledByLearnerId,
  IsSkillsCheckEnabledError,
  IsSkillsCheckEnabledSuccess,
  ResetSkillsCheckState,
  UpdateAttemptPanelState,
  UpdatePanelState,
} from "./skills-check-tab.actions";
import {
  initialSkillsCheckState,
  SkillsCheckState,
} from "./skills-check-tab.state";
import { getSkillsCheckTabState } from "./skills-check-tab.utils";

export const SkillsCheckTabReducers: ActionReducer<SkillsCheckState, Action> =
  createReducer(
    initialSkillsCheckState,
    on(IsSkillsCheckEnabled, (state, action): SkillsCheckState => {
      return {
        ...state,
        loading: true,
        error: null,
        enable: null,
        course: action.courseId,
      };
    }),
    on(IsSkillsCheckEnabledByLearnerId, (state, action): SkillsCheckState => {
      return {
        ...state,
        loading: true,
        error: null,
        enable: null,
        course: action.courseId,
      };
    }),
    on(IsSkillsCheckEnabledSuccess, (state, action): SkillsCheckState => {
      return {
        ...state,
        loading: false,
        enable: action.isEnabled,
      };
    }),
    on(IsSkillsCheckEnabledError, (state): SkillsCheckState => {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }),
    on(GetSkillsCheckResult, (state, action): SkillsCheckState => {
      return {
        ...state,
        loading: true,
        resultError: null,
        course: action.courseId,
      };
    }),
    on(GetSkillsCheckResultByLearnerId, (state, action): SkillsCheckState => {
      return {
        ...state,
        loading: true,
        resultError: null,
        course: action.courseId,
      };
    }),
    on(GetSkillsCheckResultSuccess, (state, action): SkillsCheckState => {
      return {
        ...state,
        loading: false,
        result: getSkillsCheckTabState(state, action.panel),
      };
    }),
    on(GetSkillsCheckResultError, (state, action): SkillsCheckState => {
      return {
        ...state,
        loading: false,
        resultError: action.error,
      };
    }),
    on(UpdatePanelState, (state, action): SkillsCheckState => {
      return {
        ...state,
        result: state.result.map((panel) =>
          panel.name === action.name
            ? action.expandPanel
              ? { ...panel, expanded: !panel.expanded }
              : action.showHideQandA
              ? {
                  ...panel,
                  showQandA: !panel.showQandA,
                }
              : panel
            : panel
        ),
      };
    }),
    on(UpdateAttemptPanelState, (state, action): SkillsCheckState => {
      return {
        ...state,
        result: state.result.map((panel) => {
          const updatedAttempts = panel.attempt.map((attempt) => {
            if (
              attempt.learnerTargetOutcomeId === action.learnerTargetOutcomeId
            ) {
              return {
                ...attempt,
                showAttemptQandA: action.showAttemptQandA
                  ? !attempt.showAttemptQandA
                  : attempt.showAttemptQandA,
                expandedAttempt: action.expandedAttempt
                  ? !attempt.expandedAttempt
                  : attempt.expandedAttempt,
              };
            }
            return attempt;
          });
          return {
            ...panel,
            attempt: updatedAttempts,
          };
        }),
      };
    }),
    on(ResetSkillsCheckState, (state): SkillsCheckState => {
      return {
        ...state,
        result: [],
        selectedSkillsCheckPanel: null,
        selectedSkillsCheckAttempts: [],
        selectedAttempt: null,
      }
    })
  );
